<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="halftitle"><a id="page_i"></a><span class="gray"><strong>LEADERS<br/>MADE<br/>HERE</strong></span><a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?31cdcd3a